import { useLazyQuery } from "@apollo/client";
import { TOP_BUYERS_BY_NDC } from "../reportTypeDefs";

export const useLazyQueryTopBuyersByNdc = (options?: any) =>
  useLazyQuery(TOP_BUYERS_BY_NDC, options);
